// if window.env is undefined it means we still don't have a response from config and we assume prod
export default () => window.env === 'prod' || window.env === 'prod-beta' || !window.env
